import script from "./share-trigger-mode.vue?vue&type=script&setup=true&lang=ts"
export * from "./share-trigger-mode.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__